import createIcon from '@/lib/create-icon'

const QuestionBallonIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'>
    <path
      d='M5.25 2.25C3.59315 2.25 2.25 3.59315 2.25 5.25V10.5C2.25 12.1569 3.59315 13.5 5.25 13.5H7.3125L9 15.75L10.6875 13.5H12.75C14.4069 13.5 15.75 12.1569 15.75 10.5V5.25C15.75 3.59315 14.4069 2.25 12.75 2.25H5.25Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M7.5 6.375V6.375C7.5 5.54657 8.17157 4.875 9 4.875H9.25C9.94036 4.875 10.5 5.43464 10.5 6.125V6.125C10.5 6.51845 10.3148 6.88893 10 7.125L9.6 7.425C9.22229 7.70828 9 8.15286 9 8.625V8.625'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M9.375 10.5C9.375 10.7071 9.20711 10.875 9 10.875C8.79289 10.875 8.625 10.7071 8.625 10.5C8.625 10.2929 8.79289 10.125 9 10.125C9.20711 10.125 9.375 10.2929 9.375 10.5Z'
      stroke='currentColor'
      fill='none'
    />
  </svg>,
  'QuestionBallonIcon'
)

export default QuestionBallonIcon
